import React from "react";
import { NavLink } from "react-router-dom";

const style = {
	fontWeight: "bold",
	color: "#00b7ff"
};

const MobileNav = ({ closeNav }) => {
	return (
		<ul className="mobile_nav_list">
			<li className="listitem" onClick={closeNav}>
				<NavLink strict activeStyle={style} to="/skills">
					<h2>About</h2>
					<p>skills</p>
				</NavLink>
			</li>
			<li className="listitem" onClick={closeNav}>
				<NavLink strict activeStyle={style} to="/projects">
					<h2>Portfolio</h2>
					<p>Some of project i worked on</p>
				</NavLink>
			</li>
			<li className="listitem" onClick={closeNav}>
				<NavLink strict activeStyle={style} to="/contactus">
					<h2>Contact</h2>
					<p>Get in touch</p>
				</NavLink>
			</li>
		</ul>
	);
};

export default MobileNav;
